// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offer-modal-overlay {

    position: fixed;
    inset: 0;

    background:
        rgba(0, 0, 0, .35);

    backdrop-filter:
        blur(10px);

    display: flex;

    justify-content: center;
    align-items: center;

    padding: 25px;

    z-index: 9999;

}


.offer-modal {

    width: 100%;
    max-width: 620px;

    max-height: 92vh;

    overflow-y: auto;

    background: white;

    border-radius: 32px;

    padding: 24px;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;

    box-shadow:

        0 20px 60px rgba(0, 0, 0, .08);

    animation:
        modalShow .35s;

    scrollbar-width: none;

}

.offer-modal::-webkit-scrollbar {

    display: none;

}


@keyframes modalShow {

    from {

        opacity: 0;

        transform:
            translateY(15px);

    }

    to {

        opacity: 1;

        transform:
            translateY(0);

    }

}


/* HEADER */

.offer-header {

    display: flex;

    align-items: center;

    gap: 18px;

    margin-bottom: 35px;

}


.offer-badge {

    width: 65px;
    height: 65px;

    border-radius: 20px;

    display: flex;

    justify-content: center;
    align-items: center;

    font-size: 26px;

    background:
        var(--primary-100);

    color: white;

}


.offer-header h2 {

    margin: 0;

    font-size: 28px;

    color: #111827;

}


.offer-header p {

    margin-top: 5px;

    color: #64748b;

}


/* ROLE GRID */

.offer-role-grid {

    display: grid;

    grid-template-columns:
        repeat(auto-fit,
            minmax(150px,
                1fr));

    gap: 16px;

}


.offer-role-card {

    padding: 22px;

    background: white;

    border-radius: 24px;

    border: 1px solid rgba(0, 0, 0, .06);

    cursor: pointer;

    display: flex;

    flex-direction: column;

    align-items: center;

    gap: 15px;

    transition: .3s;

}


.offer-role-card:hover {

    transform:
        translateY(-3px);

    border-color:
        var(--primary-100);

}


.offer-role-card.active {

    background:
        rgba(255,
            140,
            0,
            0.05);

    border-color:
        var(--primary-100);

}


.offer-role-icon {

    width: 42px;
    height: 42px;

    border-radius: 16px;

    display: flex;

    justify-content: center;
    align-items: center;

    font-size: 18px;

    background:
        rgba(255,
            140,
            0,
            0.08);

    color:
        var(--primary-100);

}


/* STEP TWO */

.offer-step-two {

    display: flex;

    flex-direction: column;

    gap: 18px;

}


.offer-step-two input,
.offer-step-two textarea,
.offer-step-two select {

    width: 100%;

    padding: 16px;

    border-radius: 18px;

    border: 1px solid rgba(0, 0, 0, .08);

    outline: none;

    font-size: 16px;

    background: #f8fafc;

    transition: .3s;

}


.offer-step-two textarea {

    min-height: 130px;

    resize: none;

    font-family: inherit;

}


.offer-step-two input:focus,
.offer-step-two textarea:focus,
.offer-step-two select:focus {

    border-color:
        var(--primary-100);

    background: white;

    box-shadow:

        0 0 0 4px rgba(255,
            140,
            0,
            0.08);

}


.offer-row {

    display: grid;

    grid-template-columns:
        1fr 1fr;

    gap: 15px;

}


/* BUTTONS */

.offer-actions {

    display: flex;

    gap: 15px;

    margin-top: 30px;

}


.offer-actions button {

    height: 55px;

    border: none;

    border-radius: 18px;

    font-size: 15px;

    font-weight: 700;

    cursor: pointer;

    flex: 1 1;

    transition: .3s;

}


.offer-cancel {

    background: #f1f5f9;

    color: #111827;

}


.offer-cancel:hover {

    background: #e2e8f0;

}


.offer-next,
.offer-publish {

    background:
        var(--primary-100);

    color: white;

}


.offer-next:hover,
.offer-publish:hover {

    background:
        var(--primary-200);

    transform:
        translateY(-2px);

}


.offer-next:disabled {

    opacity: .5;

    cursor: not-allowed;

}


/* MOBILE */

@media(max-width:768px) {

    .offer-modal-overlay {

        padding: 0;
        align-items: center;

    }

    .offer-modal {
        width: calc(100% - 20px);
        margin: 10px;
        border-radius: 24px;
        padding: 18px;
        max-height: 85vh;
    }


    .offer-header h2 {

        font-size: 22px;

    }


    .offer-role-grid {

        grid-template-columns:
            1fr 1fr;

    }


    .offer-role-card {
        padding: 12px;
        gap: 10px;
    }


    .offer-row {

        grid-template-columns:
            1fr;

    }


    .offer-actions {
        flex-direction: column-reverse;
        gap: 12px;
        margin-top: 20px;
    }

    .offer-actions button {
        width: 100%;
        min-height: 50px;
    }

}


.offer-feedback {

    display: flex;

    align-items: center;

    gap: 14px;

    padding: 16px;

    border-radius: 18px;

    margin-top: 15px;

    font-weight: 600;

    animation:
        feedbackAppear .4s;

}


.offer-feedback-icon {

    width: 35px;
    height: 35px;

    border-radius: 50%;

    display: flex;

    justify-content: center;
    align-items: center;

    font-weight: bold;

}


.offer-feedback.success {

    background:
        rgba(34,
            197,
            94,
            0.08);

    border:
        1px solid rgba(34,
            197,
            94,
            0.15);

    color:
        #16a34a;

}


.offer-feedback.success .offer-feedback-icon {

    background:
        #16a34a;

    color: white;

}


.offer-feedback.error {

    background:
        rgba(239,
            68,
            68,
            0.08);

    border:
        1px solid rgba(239,
            68,
            68,
            0.15);

    color:
        #dc2626;

}


.offer-feedback.error .offer-feedback-icon {

    background:
        #dc2626;

    color: white;

}


@keyframes feedbackAppear {

    from {

        opacity: 0;

        transform:
            translateY(10px);

    }

    to {

        opacity: 1;

        transform:
            translateY(0);

    }

}

/* CarrerUp offer studio — premium high-tech editorial layer. */
.offer-modal-overlay {
    background: rgba(20, 43, 61, .52);
}

.offer-modal {
    position: relative;
    max-width: 650px;
    padding: 24px;
    border: 1px solid rgba(148, 169, 186, .42);
    border-radius: 22px;
    color: #1d394f;
    background: #fbfcfd;
    box-shadow: 0 28px 75px rgba(12, 31, 47, .3), inset 0 1px #ffffff;
}

.offer-modal::before {
    content: "";
    position: absolute;
    top: 0;
    right: 34px;
    left: 34px;
    height: 3px;
    border-radius: 0 0 4px 4px;
    background: #e95a13;
}

.offer-header {
    align-items: flex-start;
    gap: 13px;
    margin: 5px 0 14px;
}

.offer-badge {
    flex: 0 0 auto;
    width: 47px;
    height: 47px;
    border: 1px solid #ffd5bf;
    border-radius: 14px;
    color: #e95a13;
    background: #fff4ed;
    box-shadow: 0 7px 16px rgba(30, 63, 88, .08);
    font-size: 1.08rem;
}

.offer-header > div:nth-child(2) { min-width: 0; }

.offer-header h2 {
    margin: 2px 0 4px;
    color: #1d394f;
    font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    font-size: 1.12rem;
    font-weight: 850;
    letter-spacing: -.012em;
}

.offer-header p {
    margin: 0;
    color: #71899b;
    font-size: .77rem;
    font-weight: 600;
}

.offer-close {
    display: grid;
    width: 34px;
    height: 34px;
    margin-left: auto;
    padding: 0;
    place-items: center;
    border: 1px solid #dfe9ee;
    border-radius: 10px;
    color: #4e7799;
    background: #f5f8fa;
    cursor: pointer;
    transition: .18s ease;
}

.offer-close:hover { color: #e95a13; background: #fff3ec; border-color: #ffc9aa; }

.offer-step-indicator {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 19px;
}

.offer-step-indicator span {
    display: grid;
    width: 24px;
    height: 24px;
    place-items: center;
    border: 1px solid #dce7ec;
    border-radius: 8px;
    color: #94a9ba;
    background: #f5f8fa;
    font-size: .62rem;
    font-weight: 850;
}

.offer-step-indicator span.active,
.offer-step-indicator span.done { border-color: #f4b08b; color: #e95a13; background: #fff3ec; }
.offer-step-indicator i { width: 34px; height: 1px; background: #dce7ec; }

.offer-role-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 9px;
}

.offer-role-card {
    min-height: 94px;
    padding: 12px 8px;
    gap: 8px;
    border: 1px solid #e0e9ee;
    border-radius: 13px;
    color: #345269;
    background: #f9fbfc;
    font-size: .72rem;
    font-weight: 750;
    transition: border-color .18s ease, background .18s ease, transform .18s ease, box-shadow .18s ease;
}

.offer-role-card:hover {
    transform: translateY(-2px);
    border-color: #f2b38e;
    background: #fff8f4;
    box-shadow: 0 8px 15px rgba(30, 63, 88, .07);
}

.offer-role-card.active {
    border-color: #e95a13;
    color: #d84f0d;
    background: #fff5ef;
    box-shadow: inset 0 0 0 1px rgba(233, 90, 19, .1);
}

.offer-role-icon {
    width: 31px;
    height: 31px;
    border-radius: 10px;
    color: #4e7799;
    background: #eaf1f5;
    font-size: .82rem;
}

.offer-role-card.active .offer-role-icon { color: #e95a13; background: #ffe9dc; }

.offer-step-two { gap: 11px; }

.offer-step-two input,
.offer-step-two textarea,
.offer-step-two select {
    box-sizing: border-box;
    padding: 13px 14px;
    border: 1px solid #dbe7ed;
    border-radius: 12px;
    color: #29475e;
    background: #f2f6f8;
    font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    font-size: .84rem;
    font-weight: 600;
    transition: .18s ease;
}

.offer-step-two textarea { min-height: 112px; }

.offer-step-two input:focus,
.offer-step-two textarea:focus,
.offer-step-two select:focus {
    border-color: #e95a13;
    background: #ffffff;
    box-shadow: 0 0 0 4px rgba(233, 90, 19, .09);
}

.offer-row { gap: 11px; }

.offer-actions {
    gap: 9px;
    margin-top: 18px;
    padding-top: 13px;
    border-top: 1px solid #e3ecef;
}

.offer-actions button {
    height: 43px;
    border-radius: 11px;
    font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    font-size: .77rem;
    font-weight: 850;
}

.offer-cancel { border: 1px solid #dbe6ec !important; color: #4e7799; background: #f3f7f9; }
.offer-cancel:hover { color: #29475e; background: #e7eef2; }
.offer-next, .offer-publish { border: 1px solid #e95a13 !important; background: #e95a13; box-shadow: 0 8px 18px rgba(233, 90, 19, .18); }
.offer-next:hover, .offer-publish:hover { background: #d84f0d; }

.offer-feedback { margin-top: 4px; padding: 11px 13px; border-radius: 12px; font-size: .78rem; }

@media (max-width: 768px) {
    .offer-modal-overlay { padding: 10px; align-items: flex-end; }
    .offer-modal { width: 100%; margin: 0; padding: 19px 15px; border-radius: 18px; max-height: 86vh; }
    .offer-role-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }
    .offer-role-card { min-height: 82px; padding: 10px 7px; }
    .offer-actions { flex-direction: row; gap: 8px; margin-top: 16px; }
    .offer-actions button { min-height: 43px; }
}

/* Premium CarrerUp offer modal. */
.offer-modal-overlay {
    background: rgba(20, 43, 61, .5);
    backdrop-filter: blur(14px);
}

.offer-modal {
    position: relative;
    max-width: 660px;
    padding: 26px;
    border: 1px solid rgba(148, 169, 186, .42);
    border-radius: 24px;
    color: #1d394f;
    background: #fbfcfd;
    box-shadow: 0 28px 75px rgba(12, 31, 47, .32), inset 0 1px #ffffff;
}

.offer-modal::before {
    content: "";
    position: absolute;
    top: 0;
    right: 38px;
    left: 38px;
    height: 3px;
    border-radius: 0 0 4px 4px;
    background: #e95a13;
}

.offer-header {
    gap: 14px;
    margin: 5px 0 26px;
}

.offer-badge {
    width: 54px;
    height: 54px;
    border: 1px solid rgba(233, 90, 19, .22);
    border-radius: 15px;
    color: #e95a13;
    background: #fff3ec;
    font-size: 22px;
}

.offer-header h2 {
    color: #1d394f;
    font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    font-size: 1.2rem;
    font-weight: 850;
    letter-spacing: -.01em;
}

.offer-header p {
    color: #71899b;
    font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    font-size: .82rem;
    font-weight: 500;
}

.offer-role-grid {
    gap: 10px;
}

.offer-role-card {
    min-height: 116px;
    padding: 15px 10px;
    border: 1px solid rgba(78, 119, 153, .16);
    border-radius: 15px;
    background: #ffffff;
    color: #345269;
    font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    font-size: .78rem;
    font-weight: 750;
}

.offer-role-card:hover {
    border-color: rgba(233, 90, 19, .45);
    background: #fff8f4;
    box-shadow: 0 9px 20px rgba(30, 63, 88, .08);
}

.offer-role-card.active {
    border-color: #e95a13;
    background: #fff3ec;
    box-shadow: inset 0 0 0 1px rgba(233, 90, 19, .1);
}

.offer-role-icon {
    width: 38px;
    height: 38px;
    border-radius: 11px;
    color: #4e7799;
    background: #edf3f6;
}

.offer-role-card.active .offer-role-icon {
    color: #e95a13;
    background: #ffe5d6;
}

.offer-step-two input,
.offer-step-two textarea,
.offer-step-two select {
    box-sizing: border-box;
    padding: 13px 14px;
    border: 1px solid rgba(78, 119, 153, .2);
    border-radius: 12px;
    color: #29475e;
    background: #f1f5f7;
    font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    font-size: .88rem;
}

.offer-step-two input:focus,
.offer-step-two textarea:focus,
.offer-step-two select:focus {
    border-color: #e95a13;
    background: #ffffff;
    box-shadow: 0 0 0 4px rgba(233, 90, 19, .1);
}

.offer-actions {
    gap: 10px;
    margin-top: 24px;
}

.offer-actions button {
    height: 46px;
    border-radius: 12px;
    font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    font-size: .8rem;
    font-weight: 800;
}

.offer-cancel {
    border: 1px solid rgba(78, 119, 153, .2) !important;
    color: #4e7799;
    background: #f1f5f7;
}

.offer-cancel:hover {
    color: #29475e;
    background: #e6eef2;
}

.offer-next,
.offer-publish {
    border: 1px solid #e95a13 !important;
    background: #e95a13;
    box-shadow: 0 8px 18px rgba(233, 90, 19, .2);
}

.offer-next:hover,
.offer-publish:hover {
    background: #d84f0d;
    box-shadow: 0 11px 22px rgba(233, 90, 19, .26);
}

.offer-modal button:focus-visible,
.offer-modal input:focus-visible,
.offer-modal textarea:focus-visible,
.offer-modal select:focus-visible {
    outline: 2px solid #e95a13;
    outline-offset: 2px;
}

@media(max-width:768px) {
    .offer-modal-overlay {
        align-items: center;
        padding: 14px;
    }

    .offer-modal {
        width: min(100%, 520px);
        margin: 0;
        max-height: 84svh;
        padding: 16px 13px;
        border-radius: 18px;
    }

    .offer-header {
        position: relative;
        gap: 9px;
        margin: 1px 0 10px;
        padding-right: 38px;
    }

    .offer-close {
        position: absolute;
        top: 20px;
        right: 20px;
        width: 31px;
        height: 31px;
        margin: 0;
        border-radius: 10px;
    }

    .offer-role-grid {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 7px;
    }

    .offer-role-card {
        min-height: 72px;
        padding: 8px 4px;
        gap: 5px;
        border-radius: 11px;
        font-size: .62rem;
        line-height: 1.16;
        text-align: center;
    }

    .offer-role-icon {
        width: 29px;
        height: 29px;
        border-radius: 9px;
        font-size: .72rem;
    }

    .offer-badge {
        width: 34px;
        height: 34px;
        border-radius: 10px;
        font-size: .9rem;
    }

    .offer-header h2 {
        margin: 0 0 1px;
        font-size: .94rem;
    }

    .offer-header p {
        font-size: .64rem;
        line-height: 1.25;
    }

    .offer-step-indicator {
        margin-bottom: 12px;
    }

    .offer-actions {
        margin-top: 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/componentsL/OfferModal.css"],"names":[],"mappings":"AAAA;;IAEI,eAAe;IACf,QAAQ;;IAER;0BACsB;;IAEtB;kBACc;;IAEd,aAAa;;IAEb,uBAAuB;IACvB,mBAAmB;;IAEnB,aAAa;;IAEb,aAAa;;AAEjB;;;AAGA;;IAEI,WAAW;IACX,gBAAgB;;IAEhB,gBAAgB;;IAEhB,gBAAgB;;IAEhB,iBAAiB;;IAEjB,mBAAmB;;IAEnB,aAAa;IACb,4BAA4B;IAC5B,iCAAiC;;IAEjC;;sCAEkC;;IAElC;sBACkB;;IAElB,qBAAqB;;AAEzB;;AAEA;;IAEI,aAAa;;AAEjB;;;AAGA;;IAEI;;QAEI,UAAU;;QAEV;4BACoB;;IAExB;;IAEA;;QAEI,UAAU;;QAEV;yBACiB;;IAErB;;AAEJ;;;AAGA,WAAW;;AAEX;;IAEI,aAAa;;IAEb,mBAAmB;;IAEnB,SAAS;;IAET,mBAAmB;;AAEvB;;;AAGA;;IAEI,WAAW;IACX,YAAY;;IAEZ,mBAAmB;;IAEnB,aAAa;;IAEb,uBAAuB;IACvB,mBAAmB;;IAEnB,eAAe;;IAEf;0BACsB;;IAEtB,YAAY;;AAEhB;;;AAGA;;IAEI,SAAS;;IAET,eAAe;;IAEf,cAAc;;AAElB;;;AAGA;;IAEI,eAAe;;IAEf,cAAc;;AAElB;;;AAGA,cAAc;;AAEd;;IAEI,aAAa;;IAEb;;;qBAGiB;;IAEjB,SAAS;;AAEb;;;AAGA;;IAEI,aAAa;;IAEb,iBAAiB;;IAEjB,mBAAmB;;IAEnB,oCAAoC;;IAEpC,eAAe;;IAEf,aAAa;;IAEb,sBAAsB;;IAEtB,mBAAmB;;IAEnB,SAAS;;IAET,eAAe;;AAEnB;;;AAGA;;IAEI;wBACoB;;IAEpB;0BACsB;;AAE1B;;;AAGA;;IAEI;;;;iBAIa;;IAEb;0BACsB;;AAE1B;;;AAGA;;IAEI,WAAW;IACX,YAAY;;IAEZ,mBAAmB;;IAEnB,aAAa;;IAEb,uBAAuB;IACvB,mBAAmB;;IAEnB,eAAe;;IAEf;;;;iBAIa;;IAEb;0BACsB;;AAE1B;;;AAGA,aAAa;;AAEb;;IAEI,aAAa;;IAEb,sBAAsB;;IAEtB,SAAS;;AAEb;;;AAGA;;;;IAII,WAAW;;IAEX,aAAa;;IAEb,mBAAmB;;IAEnB,oCAAoC;;IAEpC,aAAa;;IAEb,eAAe;;IAEf,mBAAmB;;IAEnB,eAAe;;AAEnB;;;AAGA;;IAEI,iBAAiB;;IAEjB,YAAY;;IAEZ,oBAAoB;;AAExB;;;AAGA;;;;IAII;0BACsB;;IAEtB,iBAAiB;;IAEjB;;;;;iBAKa;;AAEjB;;;AAGA;;IAEI,aAAa;;IAEb;eACW;;IAEX,SAAS;;AAEb;;;AAGA,YAAY;;AAEZ;;IAEI,aAAa;;IAEb,SAAS;;IAET,gBAAgB;;AAEpB;;;AAGA;;IAEI,YAAY;;IAEZ,YAAY;;IAEZ,mBAAmB;;IAEnB,eAAe;;IAEf,gBAAgB;;IAEhB,eAAe;;IAEf,SAAO;;IAEP,eAAe;;AAEnB;;;AAGA;;IAEI,mBAAmB;;IAEnB,cAAc;;AAElB;;;AAGA;;IAEI,mBAAmB;;AAEvB;;;AAGA;;;IAGI;0BACsB;;IAEtB,YAAY;;AAEhB;;;AAGA;;;IAGI;0BACsB;;IAEtB;wBACoB;;AAExB;;;AAGA;;IAEI,WAAW;;IAEX,mBAAmB;;AAEvB;;;AAGA,WAAW;;AAEX;;IAEI;;QAEI,UAAU;QACV,mBAAmB;;IAEvB;;IAEA;QACI,wBAAwB;QACxB,YAAY;QACZ,mBAAmB;QACnB,aAAa;QACb,gBAAgB;IACpB;;;IAGA;;QAEI,eAAe;;IAEnB;;;IAGA;;QAEI;mBACW;;IAEf;;;IAGA;QACI,aAAa;QACb,SAAS;IACb;;;IAGA;;QAEI;eACO;;IAEX;;;IAGA;QACI,8BAA8B;QAC9B,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;AAEJ;;;AAGA;;IAEI,aAAa;;IAEb,mBAAmB;;IAEnB,SAAS;;IAET,aAAa;;IAEb,mBAAmB;;IAEnB,gBAAgB;;IAEhB,gBAAgB;;IAEhB;0BACsB;;AAE1B;;;AAGA;;IAEI,WAAW;IACX,YAAY;;IAEZ,kBAAkB;;IAElB,aAAa;;IAEb,uBAAuB;IACvB,mBAAmB;;IAEnB,iBAAiB;;AAErB;;;AAGA;;IAEI;;;;iBAIa;;IAEb;;;;iBAIa;;IAEb;eACW;;AAEf;;;AAGA;;IAEI;eACW;;IAEX,YAAY;;AAEhB;;;AAGA;;IAEI;;;;iBAIa;;IAEb;;;;iBAIa;;IAEb;eACW;;AAEf;;;AAGA;;IAEI;eACW;;IAEX,YAAY;;AAEhB;;;AAGA;;IAEI;;QAEI,UAAU;;QAEV;4BACoB;;IAExB;;IAEA;;QAEI,UAAU;;QAEV;yBACiB;;IAErB;;AAEJ;;AAEA,+DAA+D;AAC/D;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,iEAAiE;AACrE;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,UAAU;IACV,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,4CAA4C;IAC5C,kBAAkB;AACtB;;AAEA,mCAAmC,YAAY,EAAE;;AAEjD;IACI,iBAAiB;IACjB,cAAc;IACd,oEAAoE;IACpE,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,qBAAqB;AACzB;;AAEA,qBAAqB,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;;AAEjF;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;kCACkC,qBAAqB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC9F,0BAA0B,WAAW,EAAE,WAAW,EAAE,mBAAmB,EAAE;;AAEzE;IACI,gDAAgD;IAChD,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,QAAQ;IACR,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,mGAAmG;AACvG;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,mBAAmB;IACnB,iDAAiD;AACrD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,2CAA2C,cAAc,EAAE,mBAAmB,EAAE;;AAEhF,kBAAkB,SAAS,EAAE;;AAE7B;;;IAGI,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,oEAAoE;IACpE,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,2BAA2B,iBAAiB,EAAE;;AAE9C;;;IAGI,qBAAqB;IACrB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA,aAAa,SAAS,EAAE;;AAExB;IACI,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,oEAAoE;IACpE,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,gBAAgB,oCAAoC,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC3F,sBAAsB,cAAc,EAAE,mBAAmB,EAAE;AAC3D,8BAA8B,oCAAoC,EAAE,mBAAmB,EAAE,6CAA6C,EAAE;AACxI,0CAA0C,mBAAmB,EAAE;;AAE/D,kBAAkB,eAAe,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;;AAE/F;IACI,uBAAuB,aAAa,EAAE,qBAAqB,EAAE;IAC7D,eAAe,WAAW,EAAE,SAAS,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;IAClG,mBAAmB,gDAAgD,EAAE,QAAQ,EAAE;IAC/E,mBAAmB,gBAAgB,EAAE,iBAAiB,EAAE;IACxD,iBAAiB,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;IAClE,wBAAwB,gBAAgB,EAAE;AAC9C;;AAEA,kCAAkC;AAClC;IACI,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,kEAAkE;AACtE;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,UAAU;IACV,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,oEAAoE;IACpE,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,oEAAoE;IACpE,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,oEAAoE;IACpE,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,iDAAiD;AACrD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;;;IAGI,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,oEAAoE;IACpE,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,oEAAoE;IACpE,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mDAAmD;IACnD,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,oCAAoC;IACpC,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;;IAEI,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;;;;IAII,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,uBAAuB;QACvB,SAAS;QACT,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,WAAW;QACX,YAAY;QACZ,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,gDAAgD;QAChD,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,QAAQ;QACR,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".offer-modal-overlay {\n\n    position: fixed;\n    inset: 0;\n\n    background:\n        rgba(0, 0, 0, .35);\n\n    backdrop-filter:\n        blur(10px);\n\n    display: flex;\n\n    justify-content: center;\n    align-items: center;\n\n    padding: 25px;\n\n    z-index: 9999;\n\n}\n\n\n.offer-modal {\n\n    width: 100%;\n    max-width: 620px;\n\n    max-height: 92vh;\n\n    overflow-y: auto;\n\n    background: white;\n\n    border-radius: 32px;\n\n    padding: 24px;\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n\n    box-shadow:\n\n        0 20px 60px rgba(0, 0, 0, .08);\n\n    animation:\n        modalShow .35s;\n\n    scrollbar-width: none;\n\n}\n\n.offer-modal::-webkit-scrollbar {\n\n    display: none;\n\n}\n\n\n@keyframes modalShow {\n\n    from {\n\n        opacity: 0;\n\n        transform:\n            translateY(15px);\n\n    }\n\n    to {\n\n        opacity: 1;\n\n        transform:\n            translateY(0);\n\n    }\n\n}\n\n\n/* HEADER */\n\n.offer-header {\n\n    display: flex;\n\n    align-items: center;\n\n    gap: 18px;\n\n    margin-bottom: 35px;\n\n}\n\n\n.offer-badge {\n\n    width: 65px;\n    height: 65px;\n\n    border-radius: 20px;\n\n    display: flex;\n\n    justify-content: center;\n    align-items: center;\n\n    font-size: 26px;\n\n    background:\n        var(--primary-100);\n\n    color: white;\n\n}\n\n\n.offer-header h2 {\n\n    margin: 0;\n\n    font-size: 28px;\n\n    color: #111827;\n\n}\n\n\n.offer-header p {\n\n    margin-top: 5px;\n\n    color: #64748b;\n\n}\n\n\n/* ROLE GRID */\n\n.offer-role-grid {\n\n    display: grid;\n\n    grid-template-columns:\n        repeat(auto-fit,\n            minmax(150px,\n                1fr));\n\n    gap: 16px;\n\n}\n\n\n.offer-role-card {\n\n    padding: 22px;\n\n    background: white;\n\n    border-radius: 24px;\n\n    border: 1px solid rgba(0, 0, 0, .06);\n\n    cursor: pointer;\n\n    display: flex;\n\n    flex-direction: column;\n\n    align-items: center;\n\n    gap: 15px;\n\n    transition: .3s;\n\n}\n\n\n.offer-role-card:hover {\n\n    transform:\n        translateY(-3px);\n\n    border-color:\n        var(--primary-100);\n\n}\n\n\n.offer-role-card.active {\n\n    background:\n        rgba(255,\n            140,\n            0,\n            0.05);\n\n    border-color:\n        var(--primary-100);\n\n}\n\n\n.offer-role-icon {\n\n    width: 42px;\n    height: 42px;\n\n    border-radius: 16px;\n\n    display: flex;\n\n    justify-content: center;\n    align-items: center;\n\n    font-size: 18px;\n\n    background:\n        rgba(255,\n            140,\n            0,\n            0.08);\n\n    color:\n        var(--primary-100);\n\n}\n\n\n/* STEP TWO */\n\n.offer-step-two {\n\n    display: flex;\n\n    flex-direction: column;\n\n    gap: 18px;\n\n}\n\n\n.offer-step-two input,\n.offer-step-two textarea,\n.offer-step-two select {\n\n    width: 100%;\n\n    padding: 16px;\n\n    border-radius: 18px;\n\n    border: 1px solid rgba(0, 0, 0, .08);\n\n    outline: none;\n\n    font-size: 16px;\n\n    background: #f8fafc;\n\n    transition: .3s;\n\n}\n\n\n.offer-step-two textarea {\n\n    min-height: 130px;\n\n    resize: none;\n\n    font-family: inherit;\n\n}\n\n\n.offer-step-two input:focus,\n.offer-step-two textarea:focus,\n.offer-step-two select:focus {\n\n    border-color:\n        var(--primary-100);\n\n    background: white;\n\n    box-shadow:\n\n        0 0 0 4px rgba(255,\n            140,\n            0,\n            0.08);\n\n}\n\n\n.offer-row {\n\n    display: grid;\n\n    grid-template-columns:\n        1fr 1fr;\n\n    gap: 15px;\n\n}\n\n\n/* BUTTONS */\n\n.offer-actions {\n\n    display: flex;\n\n    gap: 15px;\n\n    margin-top: 30px;\n\n}\n\n\n.offer-actions button {\n\n    height: 55px;\n\n    border: none;\n\n    border-radius: 18px;\n\n    font-size: 15px;\n\n    font-weight: 700;\n\n    cursor: pointer;\n\n    flex: 1;\n\n    transition: .3s;\n\n}\n\n\n.offer-cancel {\n\n    background: #f1f5f9;\n\n    color: #111827;\n\n}\n\n\n.offer-cancel:hover {\n\n    background: #e2e8f0;\n\n}\n\n\n.offer-next,\n.offer-publish {\n\n    background:\n        var(--primary-100);\n\n    color: white;\n\n}\n\n\n.offer-next:hover,\n.offer-publish:hover {\n\n    background:\n        var(--primary-200);\n\n    transform:\n        translateY(-2px);\n\n}\n\n\n.offer-next:disabled {\n\n    opacity: .5;\n\n    cursor: not-allowed;\n\n}\n\n\n/* MOBILE */\n\n@media(max-width:768px) {\n\n    .offer-modal-overlay {\n\n        padding: 0;\n        align-items: center;\n\n    }\n\n    .offer-modal {\n        width: calc(100% - 20px);\n        margin: 10px;\n        border-radius: 24px;\n        padding: 18px;\n        max-height: 85vh;\n    }\n\n\n    .offer-header h2 {\n\n        font-size: 22px;\n\n    }\n\n\n    .offer-role-grid {\n\n        grid-template-columns:\n            1fr 1fr;\n\n    }\n\n\n    .offer-role-card {\n        padding: 12px;\n        gap: 10px;\n    }\n\n\n    .offer-row {\n\n        grid-template-columns:\n            1fr;\n\n    }\n\n\n    .offer-actions {\n        flex-direction: column-reverse;\n        gap: 12px;\n        margin-top: 20px;\n    }\n\n    .offer-actions button {\n        width: 100%;\n        min-height: 50px;\n    }\n\n}\n\n\n.offer-feedback {\n\n    display: flex;\n\n    align-items: center;\n\n    gap: 14px;\n\n    padding: 16px;\n\n    border-radius: 18px;\n\n    margin-top: 15px;\n\n    font-weight: 600;\n\n    animation:\n        feedbackAppear .4s;\n\n}\n\n\n.offer-feedback-icon {\n\n    width: 35px;\n    height: 35px;\n\n    border-radius: 50%;\n\n    display: flex;\n\n    justify-content: center;\n    align-items: center;\n\n    font-weight: bold;\n\n}\n\n\n.offer-feedback.success {\n\n    background:\n        rgba(34,\n            197,\n            94,\n            0.08);\n\n    border:\n        1px solid rgba(34,\n            197,\n            94,\n            0.15);\n\n    color:\n        #16a34a;\n\n}\n\n\n.offer-feedback.success .offer-feedback-icon {\n\n    background:\n        #16a34a;\n\n    color: white;\n\n}\n\n\n.offer-feedback.error {\n\n    background:\n        rgba(239,\n            68,\n            68,\n            0.08);\n\n    border:\n        1px solid rgba(239,\n            68,\n            68,\n            0.15);\n\n    color:\n        #dc2626;\n\n}\n\n\n.offer-feedback.error .offer-feedback-icon {\n\n    background:\n        #dc2626;\n\n    color: white;\n\n}\n\n\n@keyframes feedbackAppear {\n\n    from {\n\n        opacity: 0;\n\n        transform:\n            translateY(10px);\n\n    }\n\n    to {\n\n        opacity: 1;\n\n        transform:\n            translateY(0);\n\n    }\n\n}\n\n/* CarrerUp offer studio — premium high-tech editorial layer. */\n.offer-modal-overlay {\n    background: rgba(20, 43, 61, .52);\n}\n\n.offer-modal {\n    position: relative;\n    max-width: 650px;\n    padding: 24px;\n    border: 1px solid rgba(148, 169, 186, .42);\n    border-radius: 22px;\n    color: #1d394f;\n    background: #fbfcfd;\n    box-shadow: 0 28px 75px rgba(12, 31, 47, .3), inset 0 1px #ffffff;\n}\n\n.offer-modal::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 34px;\n    left: 34px;\n    height: 3px;\n    border-radius: 0 0 4px 4px;\n    background: #e95a13;\n}\n\n.offer-header {\n    align-items: flex-start;\n    gap: 13px;\n    margin: 5px 0 14px;\n}\n\n.offer-badge {\n    flex: 0 0 auto;\n    width: 47px;\n    height: 47px;\n    border: 1px solid #ffd5bf;\n    border-radius: 14px;\n    color: #e95a13;\n    background: #fff4ed;\n    box-shadow: 0 7px 16px rgba(30, 63, 88, .08);\n    font-size: 1.08rem;\n}\n\n.offer-header > div:nth-child(2) { min-width: 0; }\n\n.offer-header h2 {\n    margin: 2px 0 4px;\n    color: #1d394f;\n    font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n    font-size: 1.12rem;\n    font-weight: 850;\n    letter-spacing: -.012em;\n}\n\n.offer-header p {\n    margin: 0;\n    color: #71899b;\n    font-size: .77rem;\n    font-weight: 600;\n}\n\n.offer-close {\n    display: grid;\n    width: 34px;\n    height: 34px;\n    margin-left: auto;\n    padding: 0;\n    place-items: center;\n    border: 1px solid #dfe9ee;\n    border-radius: 10px;\n    color: #4e7799;\n    background: #f5f8fa;\n    cursor: pointer;\n    transition: .18s ease;\n}\n\n.offer-close:hover { color: #e95a13; background: #fff3ec; border-color: #ffc9aa; }\n\n.offer-step-indicator {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0 0 19px;\n}\n\n.offer-step-indicator span {\n    display: grid;\n    width: 24px;\n    height: 24px;\n    place-items: center;\n    border: 1px solid #dce7ec;\n    border-radius: 8px;\n    color: #94a9ba;\n    background: #f5f8fa;\n    font-size: .62rem;\n    font-weight: 850;\n}\n\n.offer-step-indicator span.active,\n.offer-step-indicator span.done { border-color: #f4b08b; color: #e95a13; background: #fff3ec; }\n.offer-step-indicator i { width: 34px; height: 1px; background: #dce7ec; }\n\n.offer-role-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 9px;\n}\n\n.offer-role-card {\n    min-height: 94px;\n    padding: 12px 8px;\n    gap: 8px;\n    border: 1px solid #e0e9ee;\n    border-radius: 13px;\n    color: #345269;\n    background: #f9fbfc;\n    font-size: .72rem;\n    font-weight: 750;\n    transition: border-color .18s ease, background .18s ease, transform .18s ease, box-shadow .18s ease;\n}\n\n.offer-role-card:hover {\n    transform: translateY(-2px);\n    border-color: #f2b38e;\n    background: #fff8f4;\n    box-shadow: 0 8px 15px rgba(30, 63, 88, .07);\n}\n\n.offer-role-card.active {\n    border-color: #e95a13;\n    color: #d84f0d;\n    background: #fff5ef;\n    box-shadow: inset 0 0 0 1px rgba(233, 90, 19, .1);\n}\n\n.offer-role-icon {\n    width: 31px;\n    height: 31px;\n    border-radius: 10px;\n    color: #4e7799;\n    background: #eaf1f5;\n    font-size: .82rem;\n}\n\n.offer-role-card.active .offer-role-icon { color: #e95a13; background: #ffe9dc; }\n\n.offer-step-two { gap: 11px; }\n\n.offer-step-two input,\n.offer-step-two textarea,\n.offer-step-two select {\n    box-sizing: border-box;\n    padding: 13px 14px;\n    border: 1px solid #dbe7ed;\n    border-radius: 12px;\n    color: #29475e;\n    background: #f2f6f8;\n    font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n    font-size: .84rem;\n    font-weight: 600;\n    transition: .18s ease;\n}\n\n.offer-step-two textarea { min-height: 112px; }\n\n.offer-step-two input:focus,\n.offer-step-two textarea:focus,\n.offer-step-two select:focus {\n    border-color: #e95a13;\n    background: #ffffff;\n    box-shadow: 0 0 0 4px rgba(233, 90, 19, .09);\n}\n\n.offer-row { gap: 11px; }\n\n.offer-actions {\n    gap: 9px;\n    margin-top: 18px;\n    padding-top: 13px;\n    border-top: 1px solid #e3ecef;\n}\n\n.offer-actions button {\n    height: 43px;\n    border-radius: 11px;\n    font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n    font-size: .77rem;\n    font-weight: 850;\n}\n\n.offer-cancel { border: 1px solid #dbe6ec !important; color: #4e7799; background: #f3f7f9; }\n.offer-cancel:hover { color: #29475e; background: #e7eef2; }\n.offer-next, .offer-publish { border: 1px solid #e95a13 !important; background: #e95a13; box-shadow: 0 8px 18px rgba(233, 90, 19, .18); }\n.offer-next:hover, .offer-publish:hover { background: #d84f0d; }\n\n.offer-feedback { margin-top: 4px; padding: 11px 13px; border-radius: 12px; font-size: .78rem; }\n\n@media (max-width: 768px) {\n    .offer-modal-overlay { padding: 10px; align-items: flex-end; }\n    .offer-modal { width: 100%; margin: 0; padding: 19px 15px; border-radius: 18px; max-height: 86vh; }\n    .offer-role-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }\n    .offer-role-card { min-height: 82px; padding: 10px 7px; }\n    .offer-actions { flex-direction: row; gap: 8px; margin-top: 16px; }\n    .offer-actions button { min-height: 43px; }\n}\n\n/* Premium CarrerUp offer modal. */\n.offer-modal-overlay {\n    background: rgba(20, 43, 61, .5);\n    backdrop-filter: blur(14px);\n}\n\n.offer-modal {\n    position: relative;\n    max-width: 660px;\n    padding: 26px;\n    border: 1px solid rgba(148, 169, 186, .42);\n    border-radius: 24px;\n    color: #1d394f;\n    background: #fbfcfd;\n    box-shadow: 0 28px 75px rgba(12, 31, 47, .32), inset 0 1px #ffffff;\n}\n\n.offer-modal::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 38px;\n    left: 38px;\n    height: 3px;\n    border-radius: 0 0 4px 4px;\n    background: #e95a13;\n}\n\n.offer-header {\n    gap: 14px;\n    margin: 5px 0 26px;\n}\n\n.offer-badge {\n    width: 54px;\n    height: 54px;\n    border: 1px solid rgba(233, 90, 19, .22);\n    border-radius: 15px;\n    color: #e95a13;\n    background: #fff3ec;\n    font-size: 22px;\n}\n\n.offer-header h2 {\n    color: #1d394f;\n    font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n    font-size: 1.2rem;\n    font-weight: 850;\n    letter-spacing: -.01em;\n}\n\n.offer-header p {\n    color: #71899b;\n    font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n    font-size: .82rem;\n    font-weight: 500;\n}\n\n.offer-role-grid {\n    gap: 10px;\n}\n\n.offer-role-card {\n    min-height: 116px;\n    padding: 15px 10px;\n    border: 1px solid rgba(78, 119, 153, .16);\n    border-radius: 15px;\n    background: #ffffff;\n    color: #345269;\n    font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n    font-size: .78rem;\n    font-weight: 750;\n}\n\n.offer-role-card:hover {\n    border-color: rgba(233, 90, 19, .45);\n    background: #fff8f4;\n    box-shadow: 0 9px 20px rgba(30, 63, 88, .08);\n}\n\n.offer-role-card.active {\n    border-color: #e95a13;\n    background: #fff3ec;\n    box-shadow: inset 0 0 0 1px rgba(233, 90, 19, .1);\n}\n\n.offer-role-icon {\n    width: 38px;\n    height: 38px;\n    border-radius: 11px;\n    color: #4e7799;\n    background: #edf3f6;\n}\n\n.offer-role-card.active .offer-role-icon {\n    color: #e95a13;\n    background: #ffe5d6;\n}\n\n.offer-step-two input,\n.offer-step-two textarea,\n.offer-step-two select {\n    box-sizing: border-box;\n    padding: 13px 14px;\n    border: 1px solid rgba(78, 119, 153, .2);\n    border-radius: 12px;\n    color: #29475e;\n    background: #f1f5f7;\n    font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n    font-size: .88rem;\n}\n\n.offer-step-two input:focus,\n.offer-step-two textarea:focus,\n.offer-step-two select:focus {\n    border-color: #e95a13;\n    background: #ffffff;\n    box-shadow: 0 0 0 4px rgba(233, 90, 19, .1);\n}\n\n.offer-actions {\n    gap: 10px;\n    margin-top: 24px;\n}\n\n.offer-actions button {\n    height: 46px;\n    border-radius: 12px;\n    font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n    font-size: .8rem;\n    font-weight: 800;\n}\n\n.offer-cancel {\n    border: 1px solid rgba(78, 119, 153, .2) !important;\n    color: #4e7799;\n    background: #f1f5f7;\n}\n\n.offer-cancel:hover {\n    color: #29475e;\n    background: #e6eef2;\n}\n\n.offer-next,\n.offer-publish {\n    border: 1px solid #e95a13 !important;\n    background: #e95a13;\n    box-shadow: 0 8px 18px rgba(233, 90, 19, .2);\n}\n\n.offer-next:hover,\n.offer-publish:hover {\n    background: #d84f0d;\n    box-shadow: 0 11px 22px rgba(233, 90, 19, .26);\n}\n\n.offer-modal button:focus-visible,\n.offer-modal input:focus-visible,\n.offer-modal textarea:focus-visible,\n.offer-modal select:focus-visible {\n    outline: 2px solid #e95a13;\n    outline-offset: 2px;\n}\n\n@media(max-width:768px) {\n    .offer-modal-overlay {\n        align-items: center;\n        padding: 14px;\n    }\n\n    .offer-modal {\n        width: min(100%, 520px);\n        margin: 0;\n        max-height: 84svh;\n        padding: 16px 13px;\n        border-radius: 18px;\n    }\n\n    .offer-header {\n        position: relative;\n        gap: 9px;\n        margin: 1px 0 10px;\n        padding-right: 38px;\n    }\n\n    .offer-close {\n        position: absolute;\n        top: 20px;\n        right: 20px;\n        width: 31px;\n        height: 31px;\n        margin: 0;\n        border-radius: 10px;\n    }\n\n    .offer-role-grid {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n        gap: 7px;\n    }\n\n    .offer-role-card {\n        min-height: 72px;\n        padding: 8px 4px;\n        gap: 5px;\n        border-radius: 11px;\n        font-size: .62rem;\n        line-height: 1.16;\n        text-align: center;\n    }\n\n    .offer-role-icon {\n        width: 29px;\n        height: 29px;\n        border-radius: 9px;\n        font-size: .72rem;\n    }\n\n    .offer-badge {\n        width: 34px;\n        height: 34px;\n        border-radius: 10px;\n        font-size: .9rem;\n    }\n\n    .offer-header h2 {\n        margin: 0 0 1px;\n        font-size: .94rem;\n    }\n\n    .offer-header p {\n        font-size: .64rem;\n        line-height: 1.25;\n    }\n\n    .offer-step-indicator {\n        margin-bottom: 12px;\n    }\n\n    .offer-actions {\n        margin-top: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
